import { apiClient } from "@/modules/shared/utils/apiClient";

import { ConfirmPasswordResetData } from "../types/ConfirmPasswordResetData";

export const confirmPasswordReset = (data: ConfirmPasswordResetData) =>
  apiClient.post("/auth/member/password/reset", data);
